"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./SelectionMenu.scss");
var key_press_1 = require("../../../utils/key-press");
var UserAgent_1 = require("../../../helpers/Functions/UserAgent");
var Join_1 = require("../../../helpers/Functions/Join");
var SelectionMenu = React.forwardRef(function (_a, ref) {
    var _b;
    var data = _a.data, _c = _a.events, events = _c === void 0 ? {} : _c, _d = _a.options, options = _d === void 0 ? {} : _d, testId = _a.testId, uniqueId = _a.uniqueId;
    var dataOptions = data.options;
    var className = options.className, _e = options.defaultValue, defaultValue = _e === void 0 ? 0 : _e, disabled = options.disabled, label = options.label, linkHref = options.linkHref, linkOnClick = options.linkOnClick, linkText = options.linkText, style = options.style, _f = options.zIndex, zIndex = _f === void 0 ? 10 : _f;
    var onBlur = events.onBlur, onChange = events.onChange, onClick = events.onClick, onFocus = events.onFocus, onHover = events.onHover, onKeyPress = events.onKeyPress, onMouseDown = events.onMouseDown, onMouseUp = events.onMouseUp;
    var buttonRef = React.createRef();
    var closeRef = React.createRef();
    var containerRef = React.createRef();
    var dataOptionsRef = __spread(Array(dataOptions.length)).map(function (_, i) { return i; });
    var dropdownRef = React.createRef();
    var linkRef = React.createRef();
    var isMobile = true;
    if (typeof navigator !== "undefined") {
        isMobile = navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i);
    }
    var _g = __read(React.useState({
        altPressed: false,
        current: defaultValue,
        prevCurrent: defaultValue,
        searchResults: "",
        selected: defaultValue,
        show: false,
        showClose: false,
        showFocus: true,
        willShow: false,
    }), 2), state = _g[0], setState = _g[1];
    var _h = __read(React.useState(null), 2), timer = _h[0], setTimer = _h[1];
    var altPressed = state.altPressed, current = state.current, prevCurrent = state.prevCurrent, selected = state.selected, show = state.show, showClose = state.showClose, showFocus = state.showFocus, willShow = state.willShow;
    var setFocus = function (value) {
        if (value !== showFocus) {
            setState(__assign(__assign({}, state), { showFocus: value }));
        }
    };
    var setFocusFalse = function () {
        setFocus(false);
    };
    var setFocusTrue = function () {
        setFocus(true);
    };
    React.useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (process.browser) {
            document.addEventListener("mousedown", setFocusFalse, false);
            document.addEventListener("keydown", setFocusTrue, false);
        }
        if (show) {
            if (showClose) {
                (_a = closeRef === null || closeRef === void 0 ? void 0 : closeRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                return;
            }
            if (current === -1) {
                return;
            }
            if (process.browser) {
                document.addEventListener("mouseup", handleMouseUp, false);
            }
            (_b = dataOptionsRef[current]) === null || _b === void 0 ? void 0 : _b.focus();
            if (!UserAgent_1.isIE() && (dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) !== null && ((_c = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _c === void 0 ? void 0 : _c.scrollTo)) {
                (_d = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _d === void 0 ? void 0 : _d.scrollTo(0, (_e = dataOptionsRef[current]) === null || _e === void 0 ? void 0 : _e.offsetTop);
            }
            if (current === 0) {
                setTimeout(function () {
                    if ((dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) !== null) {
                        dropdownRef.current.scrollTop = 0;
                    }
                }, 0);
            }
            if (willShow && (dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) && (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current)) {
                var el = document.getElementById(uniqueId + "-listbox");
                if (el) {
                    var rect = el.getBoundingClientRect();
                    if (window.pageYOffset >
                        window.pageYOffset + rect.top - ((_f = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _f === void 0 ? void 0 : _f.offsetHeight) &&
                        window.pageYOffset < window.pageYOffset + rect.top) {
                        window.scrollTo(window.pageXOffset, window.pageYOffset + rect.top - ((_g = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _g === void 0 ? void 0 : _g.offsetHeight));
                    }
                    else if (window.pageYOffset + rect.top - ((_h = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _h === void 0 ? void 0 : _h.offsetHeight) >
                        window.pageYOffset +
                            rect.top -
                            window.innerHeight + ((_j = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _j === void 0 ? void 0 : _j.offsetHeight) &&
                        window.pageYOffset - ((_k = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _k === void 0 ? void 0 : _k.offsetHeight) <
                            window.pageYOffset +
                                rect.top -
                                window.innerHeight + ((_l = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _l === void 0 ? void 0 : _l.offsetHeight) +
                                32) {
                        window.scrollTo(window.pageXOffset, window.pageYOffset +
                            rect.top -
                            window.innerHeight + ((_m = dropdownRef === null || dropdownRef === void 0 ? void 0 : dropdownRef.current) === null || _m === void 0 ? void 0 : _m.offsetHeight) +
                            32);
                    }
                    setState(__assign(__assign({}, state), { willShow: false }));
                }
            }
        }
        return function cleanup() {
            if (process.browser) {
                document.removeEventListener("mouseup", handleMouseUp, false);
                document.removeEventListener("mousedown", setFocusFalse, false);
                document.removeEventListener("keydown", setFocusTrue, false);
            }
        };
    });
    React.useEffect(function () {
        onChangeEvent();
    }, [state.selected]);
    React.useEffect(function () {
        setState(__assign(__assign({}, state), { selected: defaultValue }));
    }, [defaultValue]);
    /* Event Handlers */
    var onChangeEvent = function () {
        if (onChange) {
            onChange(state);
        }
    };
    var onBlurEvent = function () {
        if (onBlur) {
            onBlur(state);
        }
    };
    var onClickEvent = function () {
        if (onClick) {
            onClick(state);
        }
    };
    var onFocusEvent = function () {
        if (onFocus) {
            onFocus(state);
        }
    };
    var onMouseDownEvent = function () {
        if (onMouseDown) {
            onMouseDown(state);
        }
    };
    var onMouseUpEvent = function () {
        if (onMouseUp) {
            onMouseUp(state);
        }
    };
    var onHoverEvent = function () {
        if (onHover) {
            onHover(state);
        }
    };
    var onKeyPressEvent = function (k) {
        if (onKeyPress) {
            onKeyPress(k, state);
        }
    };
    var showDropdown = function () {
        if (!disabled) {
            setState(__assign(__assign({}, state), { show: true, willShow: true }));
            onClickEvent();
        }
    };
    var hideDropdown = function () {
        var _a;
        if ((buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) !== null) {
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setState(__assign(__assign({}, state), { current: selected === -1 ? 0 : selected, prevCurrent: current, show: false, showClose: false }));
    };
    var toggleDropdown = function () {
        var func = function () {
            if (show) {
                hideDropdown();
            }
            else {
                showDropdown();
            }
        };
        if (isMobile) {
            clearTimeout(timer);
            setTimer(setTimeout(func, 75));
        }
        else {
            func();
        }
    };
    var handleSelection = function (i) {
        var _a;
        if ((buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) !== null) {
            (_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
        setState(__assign(__assign({}, state), { current: i, prevCurrent: current, selected: i, show: false, showClose: false }));
    };
    var handleMouseUp = function (e) {
        var _a;
        if ((containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) !== null && ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        else {
            hideDropdown();
        }
    };
    var searchOptions = function (e) {
        var letterChar = key_press_1.isLetterChar(e);
        var specialChar = key_press_1.isSpecialChar(e, state.altPressed);
        var digitChar = key_press_1.isDigitChar(e);
        var keyChar = letterChar
            ? letterChar
            : specialChar
                ? specialChar
                : digitChar
                    ? digitChar
                    : undefined;
        if (!keyChar) {
            setState(__assign(__assign({}, state), { current: state.selected, prevCurrent: current, searchResults: "" }));
            return;
        }
        var temp = (state.searchResults + keyChar).toLowerCase();
        for (var i = 0; i < dataOptions.length; i++) {
            if (dataOptions[i].label.substring(0, temp.length).toLowerCase() === temp) {
                setState(__assign(__assign({}, state), { current: i, prevCurrent: current, searchResults: temp }));
                return;
            }
        }
        temp = keyChar.toLowerCase();
        for (var i = 0; i < dataOptions.length; i++) {
            if (dataOptions[i].label.substring(0, temp.length).toLowerCase() === temp) {
                setState(__assign(__assign({}, state), { current: i, prevCurrent: current, searchResults: temp }));
                return;
            }
        }
        setState(__assign(__assign({}, state), { current: state.selected, prevCurrent: current, searchResults: "" }));
    };
    var keyDownDropdown = function (e) {
        var _a, _b;
        onKeyPressEvent(e);
        if (key_press_1.KeyPress.tabIsPressed(e)) {
            if ((options === null || options === void 0 ? void 0 : options.linkText) && (linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) &&
                document.getElementById(uniqueId + "-link") !== document.activeElement &&
                !e.shiftKey) {
                (_a = linkRef === null || linkRef === void 0 ? void 0 : linkRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                setState(__assign(__assign({}, state), { current: -1, prevCurrent: current !== -1 ? current : prevCurrent }));
            }
            else if (!e.shiftKey) {
                setState(__assign(__assign({}, state), { current: -1, prevCurrent: current !== -1 ? current : prevCurrent, showClose: true }));
            }
            else if (e.shiftKey &&
                (document.getElementById(uniqueId + "-link") !== document.activeElement ||
                    document.getElementById(uniqueId + "-close") !== document.activeElement) && (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current)) {
                (_b = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            e.preventDefault();
            return;
        }
        e.preventDefault();
        if (key_press_1.KeyPress.downArrowIsPressed(e)) {
            if (current < dataOptions.length - 1) {
                setState(__assign(__assign({}, state), { current: current + 1, prevCurrent: current }));
            }
            else {
                setState(__assign(__assign({}, state), { current: 0, prevCurrent: current }));
            }
        }
        else if (key_press_1.KeyPress.upArrowIsPressed(e)) {
            if (current > 0) {
                setState(__assign(__assign({}, state), { current: current - 1, prevCurrent: current }));
            }
            else {
                setState(__assign(__assign({}, state), { current: dataOptions.length - 1, prevCurrent: current }));
            }
        }
        else if (key_press_1.KeyPress.homeIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: 0, prevCurrent: current }));
        }
        else if (key_press_1.KeyPress.endIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: dataOptions.length - 1, prevCurrent: current }));
        }
        else if (key_press_1.KeyPress.pageUpIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current - 3 >= 0 ? current - 3 : 0, prevCurrent: current }));
        }
        else if (key_press_1.KeyPress.pageDownIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current + 3 < dataOptions.length ? current + 3 : dataOptions.length - 1, prevCurrent: current }));
        }
        else if (key_press_1.KeyPress.escIsPressed(e)) {
            hideDropdown();
        }
        else if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
            handleSelection(current !== -1 ? current : selected);
        }
        else if (key_press_1.KeyPress.altIsPressed(e) || key_press_1.KeyPress.shiftIsPressed(e)) {
            if (!altPressed) {
                setState(__assign(__assign({}, state), { altPressed: true }));
            }
        }
        else {
            searchOptions(e);
        }
    };
    var onBlurClose = function () {
        setState(__assign(__assign({}, state), { showClose: false }));
    };
    var keyDownClose = function (e) {
        var _a;
        if (key_press_1.KeyPress.tabIsPressed(e) && !e.shiftKey) {
            hideDropdown();
        }
        else if (key_press_1.KeyPress.tabIsPressed(e) && e.shiftKey && !options.linkText) {
            (_a = dataOptionsRef[prevCurrent]) === null || _a === void 0 ? void 0 : _a.focus();
            setState(__assign(__assign({}, state), { current: prevCurrent, showClose: false }));
        }
    };
    var keyDownLink = function (e) {
        var _a;
        if (key_press_1.KeyPress.tabIsPressed(e) && e.shiftKey) {
            (_a = dataOptionsRef[prevCurrent]) === null || _a === void 0 ? void 0 : _a.focus();
            setState(__assign(__assign({}, state), { current: prevCurrent, showClose: false }));
        }
    };
    var onMouseLeaveDropdown = function () {
        setState(__assign(__assign({}, state), { current: current !== -1 ? current : selected, prevCurrent: current }));
    };
    var onClickLink = function (e) {
        hideDropdown();
        if (linkOnClick) {
            linkOnClick(e);
        }
    };
    var ariaActiveDescendant = !UserAgent_1.isIE() ? uniqueId + "-selection-" + selected : "";
    return (React.createElement("div", { className: Join_1.join([className, show ? "active" : ""]), "data-testid": testId, ref: ref, style: style ? style : {} },
        label && (React.createElement("label", { className: Join_1.join([
                "formfield-label",
                styles.label,
                disabled ? "disabled" : "",
            ]), htmlFor: uniqueId }, label)),
        React.createElement("div", { className: "rel" + (className ? " " + className : ""), "data-test-id": testId, ref: containerRef, style: { zIndex: state.show ? zIndex : undefined } },
            React.createElement(React.Fragment, null,
                React.createElement("button", { "aria-disabled": disabled, "aria-expanded": show, "aria-controls": uniqueId + "-listbox", "aria-haspopup": "listbox", "aria-label": "" + (dataOptions[state.selected].group
                        ? "Group " + dataOptions[state.selected].group + ": "
                        : "") + (dataOptions[state.selected].ariaLabel
                        ? dataOptions[state.selected].ariaLabel
                        : dataOptions[state.selected].label) + " " + (dataOptions[state.selected].ariaDescription
                        ? dataOptions[state.selected].ariaDescription
                        : dataOptions[state.selected].description) + (dataOptions[state.selected].ariaSubDescription
                        ? " " + dataOptions[state.selected].ariaSubDescription
                        : dataOptions[state.selected].subDescription
                            ? " " + dataOptions[state.selected].subDescription
                            : "") + " is selected", "aria-owns": uniqueId + "-listbox", className: "dropdown-button " + styles.dropdownButton + " inline-block nowrap text-left" + (state.selected === -1 ? "" : " pad-none") + (disabled ? " border-ui-gray" : "") + (showFocus ? " " + styles.dropdownButtonFocus : ""), disabled: disabled, id: uniqueId, onBlur: onBlurEvent, onClick: toggleDropdown, onFocus: onFocusEvent, onMouseDown: onMouseDownEvent, onMouseOver: onHoverEvent, onMouseUp: onMouseUpEvent, ref: buttonRef }, state.selected === -1 ? ("Select Menu Option") : (React.createElement(SelectionInner, { description: dataOptions[state.selected].description, icon: dataOptions[state.selected].icon, innerCustomClass: dataOptions[state.selected].innerCustomClass, isDisabled: disabled, isDisplayed: true, label: dataOptions[state.selected].label, subDescription: dataOptions[state.selected].subDescription }))),
                React.createElement("div", { className: "rel" + (show ? " " + styles.optionWrapperOpen : "") },
                    React.createElement("div", { "aria-expanded": show, "aria-label": "Select from menu:", className: "optionWrapper" + (state.show ? " open" : "") + " " + styles.optionWrapper + (linkText ? " " + styles.selectionMenuWithLink : "") + " overflow-y-scroll", id: uniqueId + "-listbox", onKeyDown: keyDownDropdown, onMouseLeave: onMouseLeaveDropdown, ref: dropdownRef, role: "listbox" },
                        dataOptions.map(function (option, i) {
                            if ("group" in option &&
                                (i === 0 ||
                                    dataOptions[i].group !== dataOptions[i - 1].group)) {
                                return [
                                    React.createElement("label", { "aria-hidden": true, className: "block color-ui-dark-gray font-medium pad-b-xxs pad-l-xs pad-t-xxs mar-b-none type-sm uppercase" + (state.show
                                            ? ""
                                            : " hide " + styles.selectionMenuHide), key: "Group-Label" + i }, option.group),
                                    React.createElement("button", { "aria-label": "Group " + option.group + ": " + (option.ariaLabel
                                            ? option.ariaLabel
                                            : option.label) + " " + (option.ariaDescription
                                            ? option.ariaDescription
                                            : option.description) + (option.ariaSubDescription
                                            ? " " + option.ariaSubDescription
                                            : option.subDescription
                                                ? " " + option.subDescription
                                                : "") + (state.selected === i ? " selected" : ""), "aria-posinset": i + 1, "aria-selected": selected === i ? true : false, "aria-setsize": dataOptions.length, className: "optgroup-wrapper option-list-item bg-ui-white pad-none no-border " + styles.optionListItem + (state.show
                                            ? ""
                                            : " hide " + styles.selectionMenuHide), id: uniqueId + "-selection-" + i, key: i, name: option.value, onClick: handleSelection.bind(null, i), ref: function (node) {
                                            dataOptionsRef[i] = node;
                                        }, role: "option", type: "button" },
                                        React.createElement(SelectionInner, { description: option.description, icon: option.icon, innerCustomClass: option.innerCustomClass, label: option.label, selected: state.selected === i ? true : false, subDescription: option.subDescription })),
                                ];
                            }
                            else {
                                return (React.createElement("button", { "aria-label": "" + (option.group ? "Group " + option.group + ": " : "") + (option.ariaLabel
                                        ? option.ariaLabel
                                        : option.label) + " " + (option.ariaDescription
                                        ? option.ariaDescription
                                        : option.description) + (option.ariaSubDescription
                                        ? " " + option.ariaSubDescription
                                        : option.subDescription
                                            ? " " + option.subDescription
                                            : "") + (state.selected === i ? " selected" : ""), "aria-posinset": i + 1, "aria-selected": selected === i, "aria-setsize": dataOptions.length, className: "optgroup-wrapper option-list-item bg-ui-white pad-none no-border " + styles.optionListItem + (state.show
                                        ? ""
                                        : " hide " + styles.selectionMenuHide), id: uniqueId + "-selection-" + i, key: i, onClick: handleSelection.bind(null, i), ref: function (node) {
                                        dataOptionsRef[i] = node;
                                    }, role: "option" },
                                    React.createElement(SelectionInner, { description: option.description, icon: option.icon, innerCustomClass: option.innerCustomClass, label: option.label, selected: state.selected === i ? true : false, subDescription: option.subDescription })));
                            }
                        }),
                        linkText && (React.createElement("div", { className: "rel bottom" + (state.show ? "" : " hide " + styles.selectionMenuHide) },
                            React.createElement("div", { className: "optgroup-wrapper option-list-item bg-ui-white " + styles.selectionMenuLink },
                                React.createElement("span", { style: { cursor: "pointer" } },
                                    React.createElement("a", { className: "link-utility-primary solo pad-l-xxs " + styles.selectionMenuLinkInner, href: linkHref, id: uniqueId + "-link", onClick: onClickLink, onKeyDown: keyDownLink, ref: linkRef, role: linkHref === undefined
                                            ? "button"
                                            : undefined, tabIndex: 0 }, linkText)))))),
                    React.createElement("button", { "aria-hidden": !show, "aria-label": "Close dropdown", className: "btn-small btn-primary-2 absolute " + (showClose ? "" : " " + styles.selectionMenuCloseHide) + (options && options.closeBtnClass
                            ? " " + options.closeBtnClass
                            : ""), id: uniqueId + "-close", onBlur: onBlurClose, onClick: hideDropdown, onKeyDown: keyDownClose, ref: closeRef, role: "button", style: {
                            top: show
                                ? (_b = document.getElementById(uniqueId + "-listbox")) === null || _b === void 0 ? void 0 : _b.offsetHeight : 0,
                        }, tabIndex: show ? 0 : -1 }, "Close"))))));
});
var SelectionInner = function (_a) {
    var description = _a.description, icon = _a.icon, innerCustomClass = _a.innerCustomClass, isDisabled = _a.isDisabled, _b = _a.isDisplayed, isDisplayed = _b === void 0 ? false : _b, label = _a.label, subDescription = _a.subDescription, _c = _a.selected, selected = _c === void 0 ? false : _c;
    return (React.createElement("div", { "aria-hidden": true, className: "flex flex-1 flex-items-center " + (innerCustomClass ? "" + innerCustomClass : "") + (isDisplayed ? "" : " " + styles.selectionMenuInnerHover) + " " },
        React.createElement("div", { className: "flex flex-items-center justify-center " + styles.selectionMenuIcon }, React.cloneElement(icon, { "aria-label": label, role: "img" })),
        React.createElement("div", { className: (isDisabled ? "color-ui-gray" : isDisplayed ? "color-ui-black" : "color-ui-dark-gray") + " flex flex-1 flex-column overflow-hidden pad-b-xxs pad-t-xxs " + styles.selectionMenuInnerText + (isDisplayed ? " pad-r-md-all" : "") },
            React.createElement("span", { className: "font-medium line-h-md mar-b-none overflow-hidden text-left type-sm" + (selected ? " color-cobalt" : " pad-r-xs") }, label),
            React.createElement("span", { className: "mar-b-none line-h-md overflow-hidden text-left type-sm" + (selected ? " color-cobalt" : " pad-r-xs") }, description),
            subDescription && (React.createElement("span", { className: "mar-b-none line-h-md overflow-hidden text-left type-sm" + (selected ? " color-cobalt" : " pad-r-xs") }, subDescription))),
        selected && (React.createElement("div", { className: "flex flex-items-center justify-center " + styles.selectionMenuCheck },
            React.createElement("svg", { width: "32", height: "32", viewBox: "0 0 32 32" },
                React.createElement("path", { d: "m24.8653297 9.83653941c.6397776.65715569.6213088 1.70525139-.0354372 2.33385609-1.3803706 1.3709-2.3707788 2.3864303-5.2188499 5.3321191-.1018422.1053303-.1018422.1053303-.2036954.2106578-2.1334052 2.2060798-3.3511506 3.4512388-4.6352461 4.7263618-.6067873.5996701-1.5724289.6441499-2.2314955.1037156l-5.14881946-4.2043013c-.08021331-.0542355-.1554941-.1155381-.22471175-.1828924-.657779-.6390358-.66850157-1.6875444-.02363594-2.3398245.64301794-.6499908 1.6938697-.6605458 2.32094764-.0490073l4.00221941 3.2654768c1.0466469-1.0549369 1.9099826-1.942317 4.1650259-4.2704945.109358-.1129018.109358-.1129018.2187283-.2258001 2.116577-2.1847497 3.3358628-3.4298026 4.6147267-4.6998686.3005861-.30816229.7094537-.48799264 1.1405702-.50198738.4723161-.01799646.930024.16418824 1.2596731.50198889z", fill: "#0057b8", fillRule: "evenodd" }))))));
};
exports.default = SelectionMenu;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/SelectionMenu/SelectionMenu.js
// module id = 1810
// module chunks = 8